import { useEffect, useState } from "react";
import { useCallbackPrompt } from "../../../../hooks/useCallbackPrompt";

import "./Languages.css";
import BeatLoader from "react-spinners/BeatLoader";
import { Box } from "@mui/system";
import { Col, Row } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { getSystemLanguages } from "../../../../services/system_language";
import {
  getActiveStudyLanguages,
  moveLanguageFromLeftToRightService,
  moveLanguageFromRightToLeftService,
} from "../../../../services/study_languages";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";

export const loadContainerStyles = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  height: "70vh",
};

export const rowSpacing = {
  marginTop: "2%",
};

const NewLanguage = () => {
  const [load, setLoad] = useState(false);
  const [leftItems, setLeftItems] = useState([]);
  const [rightItems, setRightItems] = useState([]);

  const navigate = useNavigate();

  const [showDialog, setShowDialog] = useState(false);
  const [showPrompt, confirmNavigation, cancelNavigation] =
    useCallbackPrompt(showDialog);

  useEffect(() => {
    getLeftSideData();
    getRightSideData();
  }, []);

  const getLeftSideData = async () => {
    try {
      setLoad(true);
      const res = await getSystemLanguages(1, 10000);
      console.log("Res", res);

      if (res?.status === "Success") {
        setLeftItems(res?.result);
      }
    } catch (err) {
      console.log("Error: ", err?.message);
    } finally {
      setLoad(false);
    }
  };

  const getRightSideData = async () => {
    try {
      setLoad(true);
      const res = await getActiveStudyLanguages();
      if (res?.status === 200) {
        setRightItems(res?.data?.result);
      }
    } catch (err) {
      console.log("Error: ", err?.message);
    } finally {
      setLoad(false);
    }
  };

  console.log("LEft,right", leftItems, rightItems);

  const handleDragEnd = async (result) => {
    const { source, destination } = result;

    if (!destination) return;

    // Reordering within the same column (no API)
    if (source.droppableId === destination.droppableId) {
      const items =
        source.droppableId === "left" ? [...leftItems] : [...rightItems];
      const [removed] = items.splice(source.index, 1);
      items.splice(destination.index, 0, removed);

      if (source.droppableId === "left") setLeftItems(items);
      else setRightItems(items);
    } else {
      // Moving between columns
      const sourceItems =
        source.droppableId === "left" ? [...leftItems] : [...rightItems];
      const destItems =
        destination.droppableId === "left" ? [...leftItems] : [...rightItems];

      const [removed] = sourceItems.splice(source.index, 1);
      destItems.splice(destination.index, 0, removed);

      // Update state
      if (source.droppableId === "left") setLeftItems(sourceItems);
      else setRightItems(sourceItems);

      if (destination.droppableId === "left") setLeftItems(destItems);
      else setRightItems(destItems);

      // Call API based on direction
      try {
        if (
          source.droppableId === "left" &&
          destination.droppableId === "right"
        ) {
          moveLeftToRight(removed);
        } else if (
          source.droppableId === "right" &&
          destination.droppableId === "left"
        ) {
          moveRightToLeft(removed);
        }
      } catch (err) {
        console.error(err);
      }
    }
  };

  const handleCancel = (e) => {
    e.preventDefault();
    navigate("/study-management/");
  };

  const moveLeftToRight = async (item) => {
    try {
      const payload = {
        systemLanguageId: item?.id,
        systemCountryId: item?.systemCountryId,
        cultureName: item?.cultureName,
        name: item?.name,
        displayName: item?.displayName,
        isRightToLeft: true,
      };

      const res = await moveLanguageFromLeftToRightService(payload);
      console.log("REs", res);
      if (res?.status) {
        getLeftSideData();
        getRightSideData();
      }
    } catch (err) {
      console.log("Error");
    }
  };

  const moveRightToLeft = async (item) => {
    try {
      const payload = {
        id: item?.id,
        systemLanguageId: item?.systemLanguageId,
        isActive: false,
      };
      const res = await moveLanguageFromRightToLeftService(payload);
      console.log("REs", res);
      if (res?.status) {
        getLeftSideData();
        getRightSideData();
      }
    } catch (err) {
      console.log("Error");
    }
  };

  return (
    <>
      {load ? (
        <>
          <div style={loadContainerStyles}>
            <BeatLoader color="#3661eb" />
          </div>
        </>
      ) : (
        <div className="content-body">
          <p className="study-management-link" style={{ fontWeight: "600" }}>
            <Link to="/study-management">Manage Your Study</Link> |{" "}
            <Link to="/study-management/languages">Languages</Link> -
            <b style={{ color: "gray" }}>
              {sessionStorage?.getItem("studyName")}
            </b>
          </p>

          <Row style={{ marginTop: "2%", marginBottom: "2%" }}>
            <Col md={12}>
              <div className="subjectConfiguration">
                <div className="subjectVariableHead">
                  <h1>Add languages to the study</h1>
                </div>
              </div>
            </Col>
          </Row>

          <Row style={{ marginTop: "2%", marginBottom: "2%" }}>
            <Col md={6}>
              <div className="study-management-head-start">
                <p className="study-management-heading-md">
                  Available Languages
                </p>
              </div>
            </Col>
            <Col md={6}>
              <div className="study-management-head-start">
                <p className="study-management-heading-md">
                  Selected Languages
                </p>
              </div>
            </Col>
          </Row>

          {/* Drag and drop area */}
          <DragDropContext onDragEnd={handleDragEnd}>
            <div style={{ display: "flex", gap: "20vw" }}>
              {/* Left Column */}
              <Droppable droppableId="left">
                {(provided) => (
                  <div
                    ref={provided.innerRef}
                    {...provided.droppableProps}
                    style={{
                      padding: "10px",
                      width: "400px",
                      fontSize: "large",
                      background: "#f0f0f0",
                    }}
                  >
                    {leftItems.map((item, index) => (
                      <Draggable
                        key={item.id}
                        draggableId={`left-${item.id}`}
                        index={index}
                      >
                        {(provided) => (
                          <div
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                            style={{
                              padding: "10px",
                              marginBottom: "8px",
                              backgroundColor: "#fff",
                              border: "1px solid #ccc",
                              ...provided.draggableProps.style,
                            }}
                          >
                            {item.name}
                          </div>
                        )}
                      </Draggable>
                    ))}
                    {provided.placeholder}
                  </div>
                )}
              </Droppable>

              {/* Right Column */}
              <Droppable droppableId="right">
                {(provided) => (
                  <div
                    ref={provided.innerRef}
                    {...provided.droppableProps}
                    style={{
                      padding: "10px",
                      width: "400px",
                      fontSize: "large",
                      background: "#f0f0f0",
                    }}
                  >
                    {rightItems.map((item, index) => (
                      <Draggable
                        key={item.id}
                        draggableId={`right-${item.id}`}
                        index={index}
                      >
                        {(provided) => (
                          <div
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                            style={{
                              padding: "10px",
                              marginBottom: "8px",
                              backgroundColor: "#fff",
                              border: "1px solid #ccc",
                              ...provided.draggableProps.style,
                            }}
                          >
                            {item.description}
                          </div>
                        )}
                      </Draggable>
                    ))}
                    {provided.placeholder}
                  </div>
                )}
              </Droppable>
            </div>
          </DragDropContext>

          {/* <Box
            // onSubmit={handleSubmit(()=>{})}
            component="form"
            sx={{
              height: "auto",
              width: "100%",
              // padding: "4%",
              gap: "10px",
            }}
            noValidate
            autoComplete="off"
          >
            <Row style={rowSpacing}>
              <Col md={8}></Col>
              <Col md={2}>
                <div className="study-management-head-end">
                  <button
                    onClick={(e) => {
                      handleCancel(e);
                    }}
                    className="study-management-cancel-btn"
                  >
                    Cancel
                  </button>
                </div>
              </Col>
              <Col md={2}>
                <div className="study-management-head-end">
                  <button
                    type="submit"
                    className="study-management-create-btn-md"
                  >
                    Save
                  </button>
                </div>
              </Col>
            </Row>
          </Box> */}
        </div>
      )}
    </>
  );
};

export default NewLanguage;
